export var VERSION = '2.25.1';
//# sourceMappingURL=version.js.map